/* OVRSAID — homepage motion. No dependencies.
   Everything degrades to "visible, static" if JS fails or motion is reduced. */
(function () {
  'use strict';
  if (window.__ovrsaidInit) return;
  window.__ovrsaidInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var roots = document.querySelectorAll('.ov');
    for (var i = 0; i < roots.length; i++) roots[i].classList.add('is-ready');

    var targets = document.querySelectorAll('.ov-rise, .ov-mask, .ov-reveal-img');

    if (reduced || !('IntersectionObserver' in window)) {
      for (var j = 0; j < targets.length; j++) targets[j].classList.add('is-in');
      return;
    }

    // threshold 0: elements taller than the viewport still trigger reliably
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

    for (var k = 0; k < targets.length; k++) {
      // Anything already in view on load reveals immediately rather than waiting for a scroll.
      var r = targets[k].getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) {
        targets[k].classList.add('is-in');
      } else {
        io.observe(targets[k]);
      }
    }
  });
})();